import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';

interface Props {
  /** Optional permission codes the user was missing — shown to admins for support context. */
  missingPermissions?: string[];
  /** Optional custom message. */
  message?: string;
}

export default function ForbiddenPage({ missingPermissions, message }: Props) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 480,
          width: '100%',
          p: 4,
          textAlign: 'center',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <Stack spacing={2} alignItems="center">
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              bgcolor: 'error.lighter',
              color: 'error.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <LockOutlinedIcon sx={{ fontSize: 32 }} />
          </Box>

          <Typography variant="h5" fontWeight={600}>
            Access denied
          </Typography>

          <Typography variant="body2" color="text.secondary">
            {message ||
              "You don't have permission to view this page. If you believe this is a mistake, please contact your administrator."}
          </Typography>

          {missingPermissions && missingPermissions.length > 0 && (
            <Box
              sx={{
                width: '100%',
                bgcolor: 'grey.50',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                p: 1.5,
                textAlign: 'left',
              }}
            >
              <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
                Required permission{missingPermissions.length > 1 ? 's' : ''}:
              </Typography>
              <Typography variant="caption" fontFamily="monospace" sx={{ wordBreak: 'break-all' }}>
                {missingPermissions.join(', ')}
              </Typography>
            </Box>
          )}

          <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
            <Button variant="outlined" onClick={() => navigate(-1)}>
              Go back
            </Button>
            <Button variant="contained" onClick={() => navigate('/dashboard')}>
              Go to dashboard
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
